import React from 'react'
import { PixelPageContainer } from 'pixel-base'

const ChartDetail = ({ component }: { component: React.ReactNode }) => {
  return (
    <>
      <PixelPageContainer>{component}</PixelPageContainer>
    </>
  )
}

export default ChartDetail
